import { createAsyncThunk } from "@reduxjs/toolkit";
import { UsersAPI } from "api/api/usersApi/usersApi";
import axios from "axios";
import { GetUsersByUserIdParams, GetUsersByUserIdResponse } from "api/api/usersApi/types";

export const getUsersByUserId = createAsyncThunk<GetUsersByUserIdResponse, GetUsersByUserIdParams>(
  "users/getUsersByUserId",
  async ({ userId, ...params }, { rejectWithValue }) => {
    try {
      const response = await UsersAPI.getUsersByUserId({ userId, ...params });
      return response.data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting users by user ID", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while getting users by user ID", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);